import { isHttpUrl } from './is-http-url';

// Links from the API, an agent or crawled content end up in an href or
// window.open, so only web links are followed: `javascript:` and `data:` never
// are. A relative link resolves against the app, as the browser would resolve
// it.
export function isSafeLinkUrl(url: string): boolean {
  try {
    return isHttpUrl(new URL(url, window.location.href).href);
  } catch {
    return false;
  }
}
